// extracted by mini-css-extract-plugin
export default {"container":"burger-constructor_container__VzADp"};